import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ObserversModule } from '@angular/cdk/observers';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';

import { SecondarySidebarComponent } from './secondary-sidebar/secondary-sidebar.component';

import { QuickviewService } from './quickview/quickview.service';
import { TypeaheadModule, TabsModule } from 'ngx-bootstrap';

import { ParallaxDirective } from './parallax/parallax.directive';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { FormGroupDefaultDirective } from './forms/form-group-default.directive';
import { ViewDirective } from './view/view.directive';

import { pgCollapseModule } from './collapse/collapse.module';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { ContainerComponent } from './container/container.component';
import { pageContainer } from './container/page-container.component';
import { RouterModule } from '@angular/router';
import { MenuComponent } from './menu/menu.component';
import { MenuAltComponent } from './menu/menu-alt.component';
import { MenuIconComponent } from './menu/menu-icon.component';

import { ListItemComponent } from './list-view/list-item/list-item.component';
import { ListViewContainerComponent } from './list-view/list-view-container/list-view-container.component';
import { pgRetinaDirective } from './retina/retina.directive';
import { SidebarComponent } from './sidebar/sidebar.component';
import { HeaderComponent } from './header/header.component';
import { ProgressComponent } from './progress/progress.component';
import { ProgressModule } from './progress/progress.module';
import { SearchOverlayComponent } from './search-overlay/search-overlay.component';
import { QuickviewComponent } from './quickview/quickview.component';
import { QuillModule } from 'ngx-quill';
import { pgTabsModule } from './tabs/tabs.module';
import { pgSwitchComponent } from './switch/switch.component';
import { pgSwitchModule } from './switch/switch.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoadingBarModule } from 'ngx-loading-bar';
import { pgSelectModule } from './select/select.module';
import { Ng4GeoautocompleteModule } from 'ng4-geoautocomplete';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};
import { TextMaskModule } from 'angular2-text-mask';
import { NgxPaginationModule } from 'ngx-pagination';
import { MasterFilterPipe } from '../../feature-modules/utils/pipes/master-filter.pipe';
import { pgDatePickerModule } from './datepicker/datepicker.module';
import { RoleControlsDirective } from '../../feature-modules/admin/directives/role-controls.directive';
import { PaginationCheckboxDirective } from '../../feature-modules/admin/directives/pagination-checkbox.directive';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { HorizontalMenuComponent } from './horizontal-menu/horizontal-menu.component';
import { CasualLayout, BlankComponent, CondensedComponent,
   CorporateLayout, SimplyWhiteLayout, ExecutiveLayout, RootLayout } from '../layouts';
@NgModule({
  imports: [
    CommonModule,
    ObserversModule,
    TypeaheadModule.forRoot(),
    PerfectScrollbarModule,
    RouterModule,
    ProgressModule,
    FormsModule,
    QuillModule,
    pgTabsModule,
    pgSwitchModule,
    NgbModule.forRoot(),
    LoadingBarModule,
    pgSelectModule,
    Ng4GeoautocompleteModule.forRoot(),
    TextMaskModule,
    NgxPaginationModule,
    // HttpClientModule,
    pgDatePickerModule,
    MatGridListModule,
    MatCardModule,
    MatDividerModule,
    MatListModule,
    ReactiveFormsModule,
    TabsModule,
    
  ],
  declarations: [
    SecondarySidebarComponent,
    ParallaxDirective,
    BreadcrumbComponent,
    FormGroupDefaultDirective,
    ViewDirective,
    ContainerComponent,
    pageContainer,
    MenuComponent,
    MenuAltComponent,
    MenuIconComponent,
    ListItemComponent,
    ListViewContainerComponent,
    pgRetinaDirective,
    SidebarComponent,
    HeaderComponent,
    SearchOverlayComponent,
    QuickviewComponent,
    MasterFilterPipe,
    RoleControlsDirective,
    PaginationCheckboxDirective,
    HorizontalMenuComponent,
    CasualLayout,
    BlankComponent,
    CondensedComponent,
    CorporateLayout,
    SimplyWhiteLayout,
    ExecutiveLayout,
    RootLayout,
  ],
  exports: [
    SecondarySidebarComponent,
    ParallaxDirective,
    BreadcrumbComponent,
    FormGroupDefaultDirective,
    ViewDirective,
    pgCollapseModule,
    ContainerComponent,
    pageContainer,
    MenuComponent,
    MenuAltComponent,
    MenuIconComponent,
    ListItemComponent,
    ListViewContainerComponent,
    pgRetinaDirective,
    SidebarComponent,
    HeaderComponent,
    SearchOverlayComponent,
    QuickviewComponent,
    FormsModule,
    LoadingBarModule,
    pgSelectModule,
    Ng4GeoautocompleteModule,
    NgbModule,
    TextMaskModule,
    NgxPaginationModule,
    MasterFilterPipe,
    pgDatePickerModule,
    RoleControlsDirective,
    PaginationCheckboxDirective,
    MatGridListModule,
    MatCardModule,
    MatDividerModule,
    MatListModule
  ],
  providers: [QuickviewService,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ]

})
export class SharedModule { }



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/@hornbillfx/components/shared.module.ts